import { ResourceOptions } from 'react-admin';
import { FaSitemap } from 'react-icons/fa';
import { Resources } from '../resource';

export { default as list } from './List';

export const name = Resources.perpsV1Views;
export const icon = FaSitemap;
export const options: ResourceOptions = {
  label: 'resource.perpsV1Navigation',
};
